import { DatePipe } from '@angular/common';
import { Component, Input, Self, Optional, EventEmitter, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'apc-form-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  host: { class: 'apc-form-input' },
})
export class InputComponent implements ControlValueAccessor {
  @Input() disabled: boolean;
  @Input() enabledFocus: boolean;
  @Input() label: string;
  @Input() class: string;
  @Input() placeholder: string = '';
  @Input() type: 'date' | 'time' | 'number' | 'text' | 'textarea' | 'email' | 'password' = 'text';
  @Input() rows: string;
  @Input() onEdit: boolean = false;
  @Input() isCurrency: boolean = false;
  @Output() isChanged = new EventEmitter<any>();
  @Input() isEdit: boolean = false;
  @Input() patternKeyUp : string = '';
  @Input() patternKeyDown : string = '';
  @Input() excludedChar  : string = ''

  @Input() wrapperClass : string = '';
  @Input() limitBeforeComma : number = null;
  public dateType: string = 'date';


  @ViewChild('t') t: NgbTooltip;
  @ViewChild('inputEl') inputEl;

  value: any = null;

  constructor(@Self() @Optional() public ngControl: NgControl, private datePipe: DatePipe, private cdRef: ChangeDetectorRef) {
    this.ngControl && (this.ngControl.valueAccessor = this);
  }

  getNgControlErrors(){
    if(this.ngControl != null && typeof this.ngControl != typeof undefined){
      if(this.ngControl.errors != null && typeof this.ngControl.errors != typeof undefined){
        return this.ngControl.errors;
      }
    }
    return [];
  }

  decimalWithComma(e) {
    if (this.type == 'number') {
      // if decimal number, round it
      if (e.target.value % 1 !== 0) {
        e.target.value = parseFloat(e.target.value).toFixed(1);
      }
      var k;
      document.all ? (k = e.keyCode) : (k = e.which);
      return k == 44 || (k >= 48 && k <= 57);
    }
  }
  public onChangeFn = (_: any) => {};
  public onTouchedFn = () => {};

  public registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public writeValue(obj: any): void {
    this.value = obj;
  }

  onFocus() {
    if (!this.inputEl.nativeElement.closest('.editForm')) {
      this.isEdit = false;
    } else {
      this.isEdit = true;
    }
    this.cdRef.detectChanges();
  }

  handleDateInputEdit() {
    if (!this.inputEl.nativeElement.closest('.editForm')) {
      this.dateType = 'date';
      this.isEdit = true;
    } else {
      this.dateType = 'text';
      this.isEdit = false;
    }
    this.cdRef.detectChanges();
  }

  setInputTypeDate() {
    this.dateType = 'date';
  }

  public onChange() {
    if (this.type == 'number' && this.value !== "") {
      this.value = Math.abs(this.value);
    }
    this.onChangeFn(this.value);
    this.isChanged.emit(this.value);
  }

  // work only with date input type
  clearDate() {
    this.value = null;
    this.onChangeFn(this.value);
  }

  showErrorTooltip() {
    this.t?.open();
  }

  get computedPlaceolder() {
    if (this.type !== 'date') {
      return this.placeholder;
    } else {
      if (this.value) {
        return this.datePipe.transform(this.value, 'dd/MM/yyyy');
      } else if (this.onEdit) {
        return 'dd/mm/yyyy';
      } else {
        return this.placeholder;
      }
    }
  }
  keyDownEvent($event){
    let checkValidation = true;
    if(this.limitBeforeComma){
      if(this.value){
        let checkValidation = this.value.toString().split(',')[0].length < this.limitBeforeComma;
        let toStringValue = this.value.toString()
        if(!checkValidation){
         this.value = toStringValue.substring(0, toStringValue.length - 1);
        }
      }
    }
    return checkValidation;
  }
}
